import { instanceApi } from '../../../services';

export const getPartnersLogins = (fromDate: string, toDate: string, partnershipCodes: string[], partnerId: number): Promise<any> =>
  instanceApi.post('api/partnersmanagement/getPartnershipsClientLogins', {
    fromDate,
    toDate,
    partnershipCodes,
    partnerId,
  });
